import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { OrganizationUsageStatistics } from 'types/organization_usage_statistics';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';
import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';

export function useUsageStatistics({
  enabled,
  ...options
}: UseQueryOptions<OrganizationUsageStatistics, APIError> = {}) {
  const { client } = useAPI();
  const { data: organization } = useCurrentOrganization();

  return useAuthenticatedQuery(
    ['usage-statistics', organization?.id],
    async () => {
      if (!organization) {
        return Promise.reject(new Error('No organization provided.'));
      }

      const { data } = await client.get<OrganizationUsageStatistics>(
        `/internal/orgs/${organization.id}/usage_statistics`
      );
      return data;
    },
    {
      enabled:
        enabled !== undefined
          ? enabled && Boolean(organization)
          : Boolean(organization),
      ...options,
    }
  );
}
